import Vue from 'vue'
import VueSnotify from 'vue-snotify'

const config = {
  bodyMaxLength: 500,
  closeOnClick: true,
  oneAtTime: true,
  pauseOnHover: true,
  position: 'rightTop',
  showProgressBar: true,
  timeout: 2000,
  titleMaxLength: 100,
}

Vue.use(VueSnotify, {
  toast: config
})

Vue.prototype.$toast = {
  success (title, message, dismiss = true) {
    config.timeout = dismiss ? 2000 : -1
    Vue.prototype.$snotify.success(message, title, config)
  },

  error (title, message, dismiss = false) {
    config.timeout = dismiss ? 3000 : -1
    Vue.prototype.$snotify.error(message, title, config)
  },

  info (title, message, dismiss = false) {
    config.timeout = dismiss ? 3000 : -1
    Vue.prototype.$snotify.info(message, title, config)
  },

  warning (title, message, dismiss = false) {
    config.timeout = dismiss ? 3000 : -1
    Vue.prototype.$snotify.warning(message, title, config)
  },
}
